<template>
  <v-locale-provider :rtl="isRtl">
    <v-app>
      <div class="mainWrapper">
        <router-view />
      </div>
    </v-app>
  </v-locale-provider>
</template>

<script setup lang="ts">
import { computed, watch, onMounted } from 'vue';
import { useTheme } from 'vuetify';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const theme = useTheme();
const store = useStore();
const { locale } = useI18n();

const isRtl = computed(() => store.state.lang.lang === 'ar');

onMounted(() => {
  theme.change('light');
});

watch(isRtl, (newIsRtl) => {
  document.documentElement.setAttribute('dir', newIsRtl ? 'rtl' : 'ltr');
}, { immediate: true });

watch(() => store.state.lang.lang, (newLang) => {
  locale.value = newLang;
  document.documentElement.setAttribute('lang', newLang);
}, { immediate: true });
</script>
